// extracted by mini-css-extract-plugin
export default {"instructionline":"GamesSection_instructionline__UFil-","token":"GamesSection_token__jxMPE"};